import { render, staticRenderFns } from "./productgroup-selection-dialog.vue?vue&type=template&id=7dada423&scoped=true&"
import script from "./productgroup-selection-dialog.vue?vue&type=script&lang=tsx&"
export * from "./productgroup-selection-dialog.vue?vue&type=script&lang=tsx&"
import style0 from "./productgroup-selection-dialog.vue?vue&type=style&index=0&id=7dada423&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dada423",
  null
  
)

export default component.exports